import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionLeagueRankingReceived, TypeActionTournament, } from "../actionTournament";
export var epicTournamentGetCoopRankings = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTournament.GetCoopLeagueRanking), switchMap(function (action) {
        return deps
            .netSend({
            id: CommandCode.CoopLeagueRanking,
            props: {
                coopId: action.coopId,
                eventId: action.eventId,
                playerId: action.playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            return of(actionLeagueRankingReceived(res, EventType.CoopLeague));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epics/epicTournamentGetCoopRankings.ts
// module id = 2442
// module chunks = 3